import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featuredArticles = articles.slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-12 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              精选文章
            </h2>
            <p className="text-sm text-foreground-500">
              深度评测、新手攻略、汉化教程，助你玩转galgame世界
            </p>
          </div>
          <Link
            to="/category/story"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}